var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconawesomeInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-info-circle",
    "data-name": "Icon awesome-info-circle",
    d: "M16.063.563a15.5,15.5,0,1,0,15.5,15.5A15.5,15.5,0,0,0,16.063.563Zm0,6.875a2.625,2.625,0,1,1-2.625,2.625A2.625,2.625,0,0,1,16.063,7.437Zm3.5,15.875a.75.75,0,0,1-.75.75h-5.5a.75.75,0,0,1-.75-.75v-1.5a.75.75,0,0,1,.75-.75h.75v-4h-.75a.75.75,0,0,1-.75-.75v-1.5a.75.75,0,0,1,.75-.75h4a.75.75,0,0,1,.75.75v6.25h.75a.75.75,0,0,1,.75.75Z",
    transform: "translate(-0.063 -0.063)",
    fill: "#fff",
    stroke: "#cf2969",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeInfoCircle);
export default __webpack_public_path__ + "static/media/Icon awesome-info-circle.4a9e405f3b0dfb5618b58e9e2ffee8a9.svg";
export { ForwardRef as ReactComponent };